import React from 'react'
import {Button, Space, Spin} from "antd";
import {ReloadOutlined} from '@ant-design/icons'
import '../styles/Dashboard.css'
import {
    getTopClientsInfo,
    refreshTopClientsInfo,
    getOrderCountPerDay,
    refreshOrderCountPerDay,
    getClientsSalesInformation,
    refreshClientsSalesInformation,
    getClientsCountChartInfo,
    refreshClientsCounts,
    getClientsCountTableInfo,
    getSalesInformation,
    refreshSalesInformation
} from "../api/api";

const {TopClients, OrderCountPerDay, ClientsSalesInformation,  ClientsCount, OperatorFeSalesInformation} = require("@q4us-sw/eas-ui");

const Dashboard = ()=>{
    const [loading, setLoading] = React.useState(0);

    const fetchTopClients = async()=>{
        const result = await getTopClientsInfo();
        if(result){
            return result.data
        }
    };

    const fetchOrderCountPerDay = async()=>{
        const result = await getOrderCountPerDay();
        if(result){
            return result.data
        }
    };

    const fetchClientsSalesInformation = async()=>{
        const result = await getClientsSalesInformation();
        if(result){
            return result.data
        }
    };

    const fetchClientsCounts = async()=>{
        const clientCountTableInfo = await getClientsCountTableInfo();
        const clientCountChartInfo = await getClientsCountChartInfo();

        return {clientsInfo: clientCountTableInfo.data, clientsCountChart: clientCountChartInfo.data}
    };

    const fetchSalesInformation = async()=>{
        const result = await getSalesInformation();
        if(result){
            return result.data
        }
    };

    const refreshData = async() => {
        setLoading(true)
        await refreshTopClientsInfo();
        await refreshOrderCountPerDay();
        await refreshClientsSalesInformation();
        await refreshSalesInformation();
        await refreshClientsCounts();
        setLoading(false)
    };

    return <React.Fragment>
        <Space direction={`vertical`} style={{width:"100%"}}>
            <div style={{textAlign: 'right', paddingRight: 7, paddingTop: 4, width: '100%'}} >
                <Button style={{width: 160}} icon={<ReloadOutlined />} onClick={()=>refreshData()}>Refresh</Button>
            </div>
        </Space>
        {!loading ? <div className="operator_fe_dashboard">
            <OperatorFeSalesInformation fetchData={fetchSalesInformation}/>
            <ClientsSalesInformation fetchData={fetchClientsSalesInformation}/>
            <TopClients fetchData={fetchTopClients}/>
            <ClientsCount fetchData={fetchClientsCounts}/>
            <OrderCountPerDay fetchData={fetchOrderCountPerDay}/>
        </div> : <Spin />}
    </React.Fragment>
};

export default Dashboard;